module.exports = __webpack_public_path__ + "img/transit_enterexit_black_24dp.65b44c50.svg";